import { useLang } from "@/lib/i18n";

export const Marquee = ({ items, testId = "capability-marquee" }) => {
  const { lang } = useLang();
  const row = (hidden) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
      {items.map((it, i) => (
        <span key={i} className="flex items-center" lang={lang}>
          <span className="whitespace-nowrap px-8 font-serif text-3xl italic text-[#1E3A5F] sm:text-4xl lg:text-5xl" dir="auto">{it}</span>
          <span className="h-2.5 w-2.5 rotate-45 bg-[#C59B27]" aria-hidden="true" />
        </span>
      ))}
    </div>
  );
  return (
    <section data-testid={testId} className="relative overflow-hidden border-y border-[#8EA3BC]/40 bg-white py-8 sm:py-10" aria-label="Capabilities">
      <ul className="sr-only">{items.map((it) => <li key={it}>{it}</li>)}</ul>
      <div dir="ltr" className="marquee-track flex w-max" aria-hidden="true">
        {row(false)}{row(true)}
      </div>
    </section>
  );
};
